import { BRAND, IS_HOST_BRAND } from '@/config/brand.generated'

// Adres adına göre seçilen marka (ör. kulisapp.com → Kulis) belge başlığına yansır. Varsayılan marka
// (senseiverse.net) için dokunulmaz: index.html'deki başlık aynen kalır.
export function applyBrandToDocument(
  doc: { title: string } | undefined = typeof document === 'undefined' ? undefined : document,
  brand: { appName: string } = BRAND,
  isHostBrand: boolean = IS_HOST_BRAND,
): void {
  if (!doc || !isHostBrand) return
  doc.title = brand.appName
}
